import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.scss'
import Dashboard from './pages/Dashboard'
import reportWebVitals from './reportWebVitals'
import withRoot from './withRoot'

const queryClient = new QueryClient()

if (document.getElementById('root') as HTMLElement) {
  const urlParams = new URLSearchParams(document.location.search)

  const apiKey = urlParams?.get('apiKey')!

  const config = {
    paymentMethod: urlParams?.get('paymentmethod'),
    businessType: urlParams?.get('businesstype'),
    propertyValue: urlParams?.get('propertyvalue'),
    loanRequired: urlParams?.get('loanrequired'),
    rent: urlParams?.get('rent'),
    term: urlParams?.get('term'),
    mortgageClass: urlParams?.get('mortgageclass'),
    removelenders: urlParams?.get('removelenders'),
    lender: urlParams?.get('lender'),
    initialPeriod: urlParams?.get('initialperiod'),
    fees: urlParams?.get('fees'),
    region: urlParams?.get('region'),
    discountedPurchasePrice: urlParams?.get('discountedpurchaseprice'),
    shareValue: urlParams?.get('sharevalue'),
    percentagePurchased: urlParams?.get('percentagepurchased'),
    buildingUse: urlParams?.get('buildinguse'),
    // others: urlParams?.get('others'),
    creditQuestions: urlParams?.get('creditquestions'),
    enquireButtonLink: urlParams?.get('enquire'),
    showMenuBar: urlParams?.get('showmenubar') || 'Yes',
    showDropdownMenu: urlParams?.get('showdropdownmenu') || 'Yes',
    showMonthlyPayment: urlParams?.get('showmonthlypayment') || 'Yes',
    isOffset: urlParams?.get('isoffset') || 'No',
    flexible: urlParams?.get('flexible') || false,
    buyToLetHMO: urlParams?.get('buytolethmo') || false,
    limitedCompany: urlParams?.get('limitedcompany') || false,
    adverseCredit: urlParams?.get('adversecredit') || false,
  }

  const DashboardRoot = withRoot(Dashboard, apiKey, config)

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  )
  root.render(
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <DashboardRoot />
      </QueryClientProvider>
    </BrowserRouter>
  )
}

const renderApp = (apiKey: string, config: any, element: HTMLElement) => {
  if (element) {
    const rootDiv = ReactDOM.createRoot(element)

    if (apiKey) {
      const DashboardWithRoot = withRoot(Dashboard, apiKey, config)

      rootDiv.render(
        <QueryClientProvider client={queryClient}>
          <DashboardWithRoot />
        </QueryClientProvider>
      )
    }
  } else {
    throw new Error('Element does not exist.')
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

export { renderApp }
